import { render, staticRenderFns } from "./ShopArticleView.vue?vue&type=template&id=1b7288de&scoped=true"
import script from "./ShopArticleView.vue?vue&type=script&lang=js"
export * from "./ShopArticleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7288de",
  null
  
)

export default component.exports